module.exports = __webpack_public_path__ + "img/on_demand_health_pic.0f3e50bd.png";